<div class="user-search-container" [class.user-search-container--full-width]="fullWidth()">
	<input
		#searchInput
		md-form-input
		type="text"
		[placeholder]="placeholder()"
		[value]="searchTerm()"
		(input)="onSearchTermChange($any($event.target).value)"
		(focus)="onInputFocus()"
		(blur)="onInputBlur()"
	/>

	@if (showResults()) {
		<div class="search-results-popup" (mousedown)="$event.preventDefault()">
			@if (loading()) {
				<div class="search-status">Searching...</div>
			} @else {
				@for (user of searchedUsers(); track user.userID) {
					<div class="result-option" [class.selected]="isSelected(user.userID)" (mousedown)="selectUser(user)">
						<span class="result-name">{{ user.firstName }} {{ user.lastName }}</span>
						@if ((roles()?.length ?? 0) > 1) {
							<span class="result-role">{{ user.roleName }}</span>
						}
						@if (isSelected(user.userID)) {
							<span class="check-icon">✓</span>
						}
					</div>
				}
			}
		</div>
	}
</div>

@if (showSelected() && selectedUsers().length > 0) {
	<div class="selected-users-list">
		@for (user of selectedUsers(); track user.userID) {
			<span class="selected-user-chip">
				{{ user.firstName }} {{ user.lastName }}
				<button type="button" class="chip-remove" (click)="removeUser(user)" aria-label="Remove {{ user.firstName }} {{ user.lastName }}">×</button>
			</span>
		}
	</div>
}
